// 转发平台相关

import { getForward } from "@/api/modules/public";
const actions = {
    forward({ commit }, data = {}) {
        return new Promise((resolve, reject) => {
            getForward().then(({ result }) => {
                commit("SET_FORWARD", result);
                resolve(result);
            }, error => {
                reject(error);
            })
        })
    }
}
const mutations ={
    SET_FORWARD: (state,forward) => {
        state.list = forward
    }
}
const state={
    list:[],
}
export default {
    namespaced:true,
    state,
    mutations,
    actions
}